const BookingStatus = {
  Draft: 'Draft',
  DraftEdit: 'DraftEdit',
  Pending: 'Pending',
  Confirmed: 'Confirmed',
  EditedAfterConfirmed: 'EditedAfterConfirmed',
  CancelledAfterEdited: 'CancelledAfterEdited',
  Error: 'Error',
  BookingInProgress: 'BookingInProgress',
  BookingComplete: 'BookingComplete',
  Cancelled: 'Cancelled',
  Reconciled: 'Reconciled',
  Rejected: 'Rejected',
  Expired: 'Expired'
};

export default BookingStatus;
